import { render, staticRenderFns } from "./StandardFrame.vue?vue&type=template&id=19deda20&scoped=true"
import script from "./StandardFrame.vue?vue&type=script&lang=js"
export * from "./StandardFrame.vue?vue&type=script&lang=js"
import style0 from "./StandardFrame.vue?vue&type=style&index=0&id=19deda20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19deda20",
  null
  
)

export default component.exports